exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-help-article-tsx": () => import("./../../../src/templates/helpArticle.tsx" /* webpackChunkName: "component---src-templates-help-article-tsx" */),
  "component---src-templates-help-category-tsx": () => import("./../../../src/templates/helpCategory.tsx" /* webpackChunkName: "component---src-templates-help-category-tsx" */)
}

